import { useEffect, useRef, useState } from "react";

import "../../../../styles/dashboard/insights/createSreamkeyModalIndex.css";
import {
  RavenCheckBox,
  RavenInputField,
  RavenModal,
} from "@ravenpay/raven-bank-ui";
import React from "react";
import { getDateTimeObject, removeSpace } from "../../../../utils/helpers";
import { formatDate } from "../../../../helper";
import BadgeComponent from "../../../../fragments/badge/BadgeComponent";
import { generateRandomNumber } from "../../../../utils/generateRandomNumber";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import {
  createStreamKey,
  getSingleInsightTerminals,
  getStreamKey,
} from "../../../../redux/insight";
interface ModalProps {
  visible?: boolean;
  onClose?: () => void;
  onClick?: () => void;
  btnLabel: string;
  serial?: string;
}
const CreateStreamModal = ({
  visible,
  onClose,
  serial,
  onClick,
  btnLabel,
}: ModalProps) => {
  const [completePin, setCompletePin] = useState(false);
  const [details, setDetails] = useState({
    account_number: "",
    clear_keys: false,
    use_key: "",
    expire_at: "",
    history_enabled: false,
    enable_date: false,
  });
  const { insight_terminal, loading_alert, stream_key_info } = useSelector(
    (state: RootState) => state.insights
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose && onClose();
    setDetails((prev) => {
      return { ...prev, label: "" };
    });
    setCompletePin(false);
  };

  const handleChange = (e: any) => {
    const { name, value } = e?.target;
    const newObj = { ...details, [name]: value };
    setDetails(newObj);
  };

  function generateAccountNumber() {
    const key = generateRandomNumber();
    setDetails((prev) => {
      return {
        ...prev,
        use_key: key,
      };
    });
  }

  const handleFinish = () => {
    setDetails({
      account_number: "",
      clear_keys: false,
      use_key: "",
      expire_at: "",
      history_enabled: false,
      enable_date: false,
    });

    //   const obj = {
    //     account_number: insight_terminal.terminalData.account_info.account_number,
    //   };
    //   dispatch(getStreamKey(obj as any) as any);
    //   onClose && onClose();

    // if (details?.expire_at) {
    //   const data =
    //     !details?.use_key ||
    //     removeSpace(String(details?.use_key))?.length < 6 ||
    //     !details?.expire_at;
    //   return data;
    // } else {
    //   const data =
    //     !details?.use_key ||
    //     removeSpace(String(details?.use_key))?.length < 6;
    //   return data;
    // }
  };

  const handleDisable = () => {
    // let val;
    if (details?.enable_date) {
      const data =
        !details?.use_key ||
        removeSpace(String(details?.use_key))?.length < 6 ||
        !details?.expire_at;
      return data;
    } else {
      const data =
        !details?.use_key || removeSpace(String(details?.use_key))?.length < 6;
      return data;
    }
    // return val;
  };
  const getTerminalDetails = async () => {
    const obj = {
      serial,
    };
    dispatch(getSingleInsightTerminals(obj as any) as any);
  };

  const handleGenerateKey = async () => {
    const obj = {
      ...details,
      account_number:
        insight_terminal?.terminalData?.account_info?.account_number,
    };

    const data = await dispatch(createStreamKey(obj as any) as any);

    if (data?.payload?.status === "success") {
    
      handleFinish();
    
      getTerminalDetails();
      onClose?.();
     
    } else {
      // console.error("Request failed:", data);
    }
  };
  return (
    <>
      <RavenModal
        onClose={handleClose}
        btnLabel="Generate Stream Key"
        btnColor="deep-green-light"
        visble={visible}
        disabled={handleDisable()}
        onBtnClick={handleGenerateKey}
        loading={loading_alert}
      >
        <div className="create_stream_modal_general_wrap">
          <div className="title-text-box border-theme-bottom">
            <p className="title">Create Stream Key</p>
            <p className="text grey-white-color">
              Use the stream key to manage your transactions and your inflows.
            </p>
          </div>

          <div className="form-box">
            {/* input field start */}
            <div className="stream-number-input-box">
              <RavenInputField
                type="account-number"
                color="black-light"
                className="input"
                placeholder="000000"
                value={details?.use_key}
                name={`use_key`}
                onChange={handleChange}
                maxLength={6}
              />
            </div>
            {/* input field end */}

            {/* down label box start */}
            <div className="down-label-generate-box">
              <p className="label-down grey-white-color">
                Enter a 6 digit code or{" "}
              </p>{" "}
              <BadgeComponent
                onClick={generateAccountNumber}
                className={`pending badge`}
                text={`Auto Generate Key`}
              />
            </div>
            {/* down label box end */}
          </div>
          {/* list box start */}
          <div className="list-box-to-set">
            <div className="label-check-box">
              <RavenCheckBox
                color="deep-green-light"
                checked={details.history_enabled}
                onChange={() => {
                  setDetails((prev) => ({
                    ...prev,
                    history_enabled: !prev.history_enabled,
                  }));
                }}
                id={774747899}
              />
              <p className="label grey-white-color-white">
                Enable Transaction History
              </p>
            </div>
            <div className="label-check-box">
              <RavenCheckBox
                color="deep-green-light"
                checked={details.enable_date}
                onChange={() => {
                  setDetails((prev) => ({
                    ...prev,
                    enable_date: !prev.enable_date,
                  }));
                  console.log(details.enable_date);
                }}
                id={77474789}
              />
              <p className="label grey-white-color-white">Set Expiry Date</p>
            </div>
          </div>
          {/* list box end */}
          {/* date input field start */}
          <div
            className={`date-input-wrap-box-stream ${
              details?.enable_date ? "date-input-wrap-box-stream-show" : ""
            }`}
          >
            <RavenInputField
              dateOptions={{ minDate: new Date() }}
              // enableTime
              placeholder="Select expiry date"
              value={details?.expire_at}
              onChange={(date: any) => {
                setDetails((prev) => {
                  return {
                    ...prev,
                    expire_at: getDateTimeObject(date[0])?.date,
                  };
                });
              }}
              type="date"
              color="deep-green-light"
            />
          </div>
          {/* date input field end */}
        </div>
      </RavenModal>
    </>
  );
};

export default CreateStreamModal;
